var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_c('div',{class:_vm.imageClass,style:(_vm.getImageUrl(_vm.item)),attrs:{"title":_vm.title,"role":"img","aria-label":("Image of " + (_vm.item.DisplayName))}})])}
var staticRenderFns = []

export { render, staticRenderFns }